import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)/gamification/ranking/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div className="p-6">Hello "/(protected)/gamification/ranking/"!</div>;
}
